import { BaseVisualizationData, Visualization3dData, VisualizationData } from '../data/model';
import { IImagePreloader } from '../shared/ImagePreloader';
import { VisualizationMode } from '../shared/visualization';
import { IVisualizationState } from './IVisualizationState';
import { Visualization3dState } from './Visualization3dState';
import { VisualizationFull3dState } from './VisualizationFull3dState';
import { VisualizationHybridState } from './VisualizationHybridState';
import { VisualizationState } from './VisualizationState';

export class VisualizationStateFactory {
  constructor(private readonly imagePreloader: IImagePreloader) {}

  public create(visualization: BaseVisualizationData, initialComponents: Map<string, string>): IVisualizationState {
    if (visualization.mode === VisualizationMode.Hybrid) {
      return new VisualizationHybridState(
        new Visualization3dState(visualization as Visualization3dData),
        this.imagePreloader,
        initialComponents,
      );
    } else if (visualization.mode === VisualizationMode.Full3d) {
      return new VisualizationFull3dState(visualization as Visualization3dData, initialComponents);
    } else {
      return new VisualizationState(visualization as VisualizationData, this.imagePreloader, initialComponents);
    }
  }
}
